// Pages
import Login from "./pages/login/index.jsx";
import Logout from "./pages/login/logout";
import AuthPanel from "./components/AuthPanel.jsx";
import Register from "./pages/register/index.jsx";
import Invertir from "./pages/invest/index.jsx";
import DetailsProperty from "./pages/details/property/index.jsx";
import Profile from "./pages/profile/index.jsx";
import Projects from "./pages/projects/index.jsx";
import Property from "./pages/property/index.jsx";
import Home from "./pages/home/index.jsx";
import DetailsProject from "./pages/details/project/index.jsx";
import NewProject from "./pages/newProject/index.jsx";
import NewProperty from "./pages/newProperty/index.jsx";
import MyProjects from "./pages/myProjects/index.jsx";
import EditProject from "./pages/edit/project/index.jsx";
import MyProperty from "./pages/myProperty/index.jsx";
import DashboardAdmin from "./pages/dashboard/index.jsx";
import EditProperty from "./pages/edit/property/index.jsx";
import VerifiedAccount from "./pages/verifiedAccount/index.jsx";
import ResetPwd from "./pages/recovery-password";
import MyInvestments from "./pages/myInvestments/index.jsx";
import ManageProjectAdmin from "./pages/manage/project/index.jsx";
import ManagePropertyAdmin from "./pages/manage/property/index.jsx";
import PreviewProject from "./pages/preview/project/index.jsx";
import InvestedProject from "./pages/investedProject/index.jsx";

const routes = [
  {
    route: "/me/investments",
    role: ["user"],
    component: <MyInvestments />,
  },

  {
    route: "/me/invested/project/:id",
    role: ["user"],
    component: <InvestedProject />,
  },
  {
    route: "/verified",
    role: "auth",
    component: <VerifiedAccount />,
  },
  {
    route: "/user/dashboard",
    role: ["user"],
    component: <Home />,
  },
  {
    route: "/profile",
    role: ["user"],
    component: <Profile />,
  },
  {
    route: "/property",
    role: ["user"],
    component: <Property />,
  },
  {
    route: "/me/projects",
    role: ["user"],
    component: <MyProjects />,
  },

  {
    route: "/edit/project/:id",
    role: ["user"],
    component: <EditProject />,
  },
  {
    route: "/projects",
    role: ["user"],
    component: <Projects />,
  },
  {
    route: "/invest/:id",
    role: ["user"],
    component: <Invertir />,
  },
  {
    route: "/details/property/:id",
    role: ["user"],
    component: <DetailsProperty />,
  },
  {
    route: "/details/project/:id",
    role: ["user"],
    component: <DetailsProject />,
  },
  {
    route: "/create/project",
    role: ["user"],
    component: <NewProject />,
  },

  //------------AUTH ROUTES-------------------
  {
    route: "/login",
    role: "auth",
    component: <AuthPanel Login={Login} Register={Register} />,
  },
  {
    route: "/register",
    role: "auth",
    component: <AuthPanel Login={Login} Register={Register} />,
  },
  {
    route: "/recuperar-contrasena",
    role: "auth",
    component: <ResetPwd />,
  },
  {
    route: "/logout",
    component: <Logout />,
  },

  //--------------DASHBOARD ROUTES----------------
  {
    route: "/dashboard/edit/property/:id",
    role: ["superadmin"],
    component: <EditProperty />,
  },
  {
    route: "/dashboard",
    role: ["superadmin"],
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/preview/project/:id",
    role: ["superadmin"],
    component: <PreviewProject />,
  },
  {
    route: "/dashboard/property/contacted",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/property/interest",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/manage/project/:id",
    role: "superadmin",

    component: <ManageProjectAdmin />,
  },
  {
    route: "/dashboard/manage/property/:id",
    role: "superadmin",
    component: <ManagePropertyAdmin />,
  },
  {
    route: "/dashboard/projects/accepted",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/projects/pending",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/projects/rejected",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/property/accepted",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/property/sold",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/property/rented",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/investments/accepted",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/investments/pending",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/investments/rejected",
    role: "superadmin",
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/create/property",
    role: ["superadmin"],
    component: <DashboardAdmin />,
  },
  {
    route: "/dashboard/properties",
    role: ["superadmin"],
    component: <DashboardAdmin />,
  },
];

export default routes;
